import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = ["value", "placeholder"]

import { withDefaults } from 'vue'
import { DfNode } from '@/interfaces/drawflow'

interface IProps {
  toggleDetails?: () => void
  node?: DfNode
}


export default /*#__PURE__*/_defineComponent({
  props: {
    toggleDetails: { type: Function, required: false, default: () => ({}) },
    node: { type: null, required: false, default: () => ({} as DfNode) }
  },
  setup(__props: any) {

const props = __props as { toggleDetails: () => void, node: DfNode }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('steps.trigger.desc')), 1),
      _createElementVNode("div", {
        class: "ml-1",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.toggleDetails && props.toggleDetails(...args)))
      }, [
        _createElementVNode("input", {
          class: "dynamic-field",
          disabled: "",
          value: props.node.data.eventLabel,
          placeholder: _ctx.$t('steps.empty')
        }, null, 8, _hoisted_3)
      ])
    ])
  ]))
}
}

})